<template>
  <v-container class="px-0">

  <v-card flat>
      
      <v-card-title primary-title>
        <v-icon left color="grey">mdi-cog</v-icon>
        {{ $t('Configuration') }}
      </v-card-title>

      <v-card-text>
      <v-row>
        <v-col cols="12">  
          
          <v-form ref="configForm">

            <div class="d-flex align-center">
              <v-checkbox
                v-model="userInfo.tiltAxisMode"
                :label="$t('config.tilt_axis_mode')"
              ></v-checkbox>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="ml-2">
                    <v-icon color="grey lighten-1">
                      mdi-information-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>When ON, axis are shown as indipendent x,y,z <br> When OFF, axis are shown as vertical tilt</span>
              </v-tooltip>
            </div>

            <div class="d-flex align-center">
              <v-checkbox v-model="userInfo.systemMail" :label="$t('config.system_mail')"></v-checkbox> 
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="ml-2">
                    <v-icon color="grey lighten-1">
                      mdi-information-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>View advices also for system alerts (battery or radio issues, malfunctions, ecc...)</span>
              </v-tooltip>
            </div>

            <div class="d-flex align-center">
              <v-checkbox v-model="userInfo.emailToUsers" :label="$t('config.mail_to_users')"></v-checkbox>               
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="ml-2">
                    <v-icon color="grey lighten-1">
                      mdi-information-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>For configurators profile, send advices also to related users</span>
              </v-tooltip>           
            </div>

            <div class="d-flex align-center">
              <v-checkbox v-model="userInfo.dataInterpolation" :label="$t('config.data_interpolation')"></v-checkbox>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="ml-2">
                    <v-icon color="grey lighten-1">
                      mdi-information-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>
                  Show linear interpolation data on graphs, api and exports.<br>
                  Valid only for LR-SS sensor series
                </span>
              </v-tooltip>
            </div>

            <div class="d-flex align-center">
              <v-row>
                <v-col cols="1" md="1" lg="1">
                  <v-select
                      v-model="userInfo.csvFieldSeparator"
                      :items="csvFieldSeparators"
                      :label="$t('config.csv_field_separator')"
                  ></v-select>
                </v-col>  
                <v-col cols="1" md="2" lg="1">  
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" class="ml-2">
                        <v-icon color="grey lighten-1">
                          mdi-information-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>For CSV export, chose which field separator to use</span>
                  </v-tooltip>
               </v-col> 
              </v-row>

        
            </div>
            
            <div class="d-flex align-center">
              <v-row>
                <v-col cols="1" md="1" lg="1">
                  <v-select
                    v-model="userInfo.csvDecimalSeparator"
                    :items="csvDecimalSeparators"
                    :label="$t('config.csv_decimal_separator')"
                  ></v-select>
                </v-col>
                <v-col cols="1" md="1" lg="1">
                  <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" class="ml-2">
                      <v-icon color="grey lighten-1">
                        mdi-information-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>For CSV export, chose which decimal separator to use</span>
                  </v-tooltip>
                </v-col>
              </v-row>       
            </div>

            <div class="d-flex align-center">
              <v-switch
                :label="$t('config.dark_theme')"
                v-model="userInfo.darkTheme"
                @change="setDarkTheme"
                inset
                persistent-hint
              ></v-switch>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="ml-2">
                    <v-icon color="grey lighten-1">
                      mdi-information-outline
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('config.dark_theme_hint') }}</span>
              </v-tooltip>
            </div>

          </v-form>
        </v-col>  
      </v-row>
      <v-row>
        <v-col cols="12" style="text-align:right">
          <v-btn color="success" @click="save">
            <v-icon left>mdi-floppy</v-icon>
            {{ $t('config.btn.save') }}
          </v-btn>
        </v-col>
      </v-row>  


      </v-card-text>
    </v-card>

  </v-container>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    name: 'Config',
    computed: {
      ...mapState( [
        'user',
      ]),
    },
    data () {
      return {
        breadcrumbsItems: [ 
          { href: '/home', disabled: false, text: this.$t("home").toUpperCase(), to: '/home'},
          { href: '/config', disabled: true, text: this.$t("config").toUpperCase()}
        ] ,
        userInfo: {},
        csvFieldSeparators: [',', ';'],
        csvDecimalSeparators: ['.', ',']
      }  
    },
    created: async function() {
      this.$store.dispatch('_updateBreadcrumbs', this.breadcrumbsItems);
      await this.load();
    },
    methods: {
      setDarkTheme: function (val) {
        this.$store.dispatch('_setTheme', val ? 'dark' : 'light');
        this.$vuetify.theme.dark = val;
      },
      async load() {
        const configParams = this.user.configParams || {};
        this.userInfo = {
          ...configParams,
          csvFieldSeparator: configParams.csvFieldSeparator || ';',
          csvDecimalSeparator: configParams.csvDecimalSeparator || ','
        };
      },
      async save(){
        if(!this.$refs.configForm.validate()){
          this.$store.dispatch('_snackbarMessage', {
            status: 'error',
            message: this.$t('config.form.not_valid')
          });
          return false;
        }

        try{
            await this.$store.dispatch('_updateUser', {
            data: {
            ...this.userInfo,
            configParams : {
              ...this.user.configParams || {},
              tiltAxisMode: this.userInfo.tiltAxisMode,
              systemMail: this.userInfo.systemMail,
              darkTheme: this.userInfo.darkTheme,
              dataInterpolation: this.userInfo.dataInterpolation,
              csvFieldSeparator: this.userInfo.csvFieldSeparator || ';',
              csvDecimalSeparator: this.userInfo.csvDecimalSeparator || ','
            }
            }
          })

        }catch (e) {
          this.userInfo = JSON.parse(JSON.stringify(this.userInfoInitial));
          this.$store.dispatch('_snackbarMessage', {
            status: 'error',
            message: this.$t('config.error.sending_data')
          });
        }
      },
    }
  }
</script>
